// Mantém evoluções na aba clínica e compromissos reais na aba Agendamentos.
export function filterPatientAppointments(list, patientId) {
  if (!patientId) return [];
  return (Array.isArray(list) ? list : []).filter(appointment => {
    if (appointment?.patient_id !== patientId) return false;
    return appointment.source !== 'aligner_event'
      && appointment.source !== 'clinical_evolution_manual'
      && appointment.import_category !== 'clinical_evolution'
      && appointment.procedure !== 'Evolução Clínica Manual'
      && appointment.calendar_visible !== false
      && appointment.is_clinical_evolution !== true;
  });
}
